import FlavourConfig from '../../../../shared/config/flavours';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const SplashLogo = styled.img<React.CSSProperties>`
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  width: ${FlavourConfig.sizes.splashLogo * Screen.widthRatio}px;
`;

SplashLogo.defaultProps = {
  src: FlavourConfig.images.logo,
};

export default withImage(SplashLogo);
